module.exports = __webpack_public_path__ + "img/关联企业.b8442da1.png";